import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import FormFilter from './form';

const FilterLotsManagement = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <div className="pmi-my-3">
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-lots-management-auth-content"
          id="panel-lots-management-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

FilterLotsManagement.displayName = 'Lots Management List - Filter';

export default FilterLotsManagement;
